{
    "type": "object",
    "properties": {
        "landingPage": {
            "required": true,
            "validationMessages": {
                "required": "Please select your prefered landing page."
            }
        },
        "hideLandingPagePopUp": {
            "title": "Do not show this again"
        }
    }
}